import { faPlay } from "@fortawesome/pro-solid-svg-icons";

import { FunctionComponent, useEffect, useRef, useState } from "react";

import ReactPlayer from "react-player";

import ReactDOM from "react-dom";

import { classNames } from "@/utils/classNames";

import { composedPathContains } from "@/utils/getComposedEventTarget";

import { Icon } from "../Icon/Icon";

type VideoWrapperProps = {
	youtubeId: string;
	className?: string;
};

export const VideoWrapper: FunctionComponent<VideoWrapperProps> = ({ youtubeId, className }) => {
	const thumbnailImage = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

	const [showModal, setShowModal] = useState(false);

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(e: MouseEvent) {
			e.stopPropagation();
			e.preventDefault();

			if (e.target && ref.current && !composedPathContains(ref.current, e)) {
				setTimeout(() => {
					setShowModal(false);
				}, 100);
			}
		}

		// Bind the event listener
		if (showModal) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, setShowModal, showModal]);

	const handleClick = () => {
		setShowModal(true);
	};

	const checkThumbnail = (element: HTMLImageElement) => {
		if (element.naturalWidth === 120) {
			element.parentElement?.parentElement?.remove();
		}
	};

	return (
		<>
			<div
				className={classNames(
					"cursor-pointer relative group flex flex-row justify-center items-center gap-2 w-[168px] h-[94px] rounded-sm",
					className
				)}
				onClick={handleClick}
			>
				<img
					alt="thumbnail"
					className="w-full h-full object-cover"
					src={thumbnailImage}
					onLoad={(obj) => checkThumbnail(obj.target as HTMLImageElement)}
				/>
				<div className=" bg-white border border-border-light group-hover:border-blue-action group-hover:bg-blue-action group-hover:text-white transition-all duration-300 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-row gap-2 w-9 h-9 rounded-full justify-center items-center">
					<Icon className="text-blue-action group-hover:text-white w-4 h-4 ml-1" icon={faPlay} />
				</div>
			</div>
			{showModal &&
				ReactDOM.createPortal(
					<div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center  z-[10001]">
						<div
							ref={ref}
							className=" absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 aspect-video"
						>
							<div className="w-full h-full">
								<ReactPlayer
									className="w-full h-full"
									controls={true}
									playing={true}
									src={`https://www.youtube.com/watch?v=${youtubeId}`}
									style={{
										width: "100%",
										height: "100%",
									}}
								/>
							</div>
						</div>
					</div>,
					document.body
				)}
		</>
	);
};
